'use client';

import { usePreventScroll } from '@react-aria/overlays';
import { motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { cssVar, theme } from '@zoomit/zoomit-ds';

import NotificationBody from './NotificationBody';

type Props = {
  onClose(): void;
  menuHeight: number;
};

const DesktopNotification = (props: Props) => {
  const { onClose, menuHeight } = props;

  const [offsetTop, setOffsetTop] = useState(0);
  const drawerRef = useRef<HTMLDivElement>(null);
  usePreventScroll();

  useEffect(() => {
    const refOffsetTop = drawerRef?.current?.parentElement?.getBoundingClientRect().top || 0;
    setOffsetTop(refOffsetTop);
  }, []);

  return (
    <>
      <div
        className="fixed top-0 right-0 bottom-0 left-0 z-[1] flex h-screen w-screen"
        data-testid={'dismiss-area'}
        onClick={() => onClose()}
      />
      <Drawer
        menuHeight={menuHeight}
        initial={{ x: -340 }}
        animate={{ x: 0 }}
        ref={drawerRef}
        transition={{ type: 'tween', duration: 0.2, ease: 'easeOut' }}
        offsetTop={offsetTop}
      >
        <NotificationBody onClose={() => onClose()} />
      </Drawer>
    </>
  );
};

export default DesktopNotification;

const Drawer = styled(motion.div)<{ offsetTop: number; menuHeight: number }>`
  display: flex;
  background-color: ${cssVar(theme.menu.headerBackground)};
  ${({ offsetTop, menuHeight }) => `height: calc(100vh - ${offsetTop + menuHeight}px)`};
  width: 34.4rem;
  position: absolute;
  top: ${({ menuHeight }) => menuHeight}px;
  z-index: 2;
  left: 0;
  justify-content: space-between;
  flex-direction: column;
  padding: 3rem 1.6rem;
  box-shadow: 0 1px 3px 0 rgba(25, 25, 35, 0.15);
  overflow-y: auto;
`;
